import { users } from "./authSchema.mjs";
import { json, pgTable, text, timestamp, uuid } from "drizzle-orm/pg-core";

//#region src/schema/syncSchema.ts
const syncClients = pgTable("sync_clients", {
	id: uuid("id").primaryKey().defaultRandom().notNull(),
	userId: text("user_id").references(() => users.id, { onDelete: "cascade" }),
	clientId: text("client_id").notNull().unique(),
	createdAt: timestamp("created_at").defaultNow().notNull(),
	updatedAt: timestamp("updated_at").defaultNow().$onUpdateFn(() => /* @__PURE__ */ new Date()).notNull(),
	lastScanWindow: json("last_scan_window").notNull(),
	lastMutationId: text("last_mutation_id")
});

//#endregion
export { syncClients };